const tokens = require('./tokens.json');
const colorArray = require('./colorArray');

module.exports = {
  ...tokens,
  /** @deprecated */
  tokens: {...tokens},
  colorArray,
};